/**
 * The small print every door carries: play money only, then which build is
 * on the screen. One copy for the web app and the native shells, so the
 * disclaimer an app reviewer reads on a phone is the one the browser shows.
 */
export const RELEASE_STAGE = 'alpha';

export const FREE_DURING_ALPHA = 'Free during alpha';

export const NO_REAL_MONEY =
  "Casino games here don't use real money and are just for fun. Chips have no cash value and can't be bought, sold, redeemed or exchanged for money or prizes. No real-money gambling takes place.";

/** "v0.1.0-alpha · a29b142", or "dev-alpha" when nothing was stamped. */
export function buildLabel(version: string, commit = ''): string {
  const base = version === 'dev' ? `dev-${RELEASE_STAGE}` : `v${version}-${RELEASE_STAGE}`;
  return commit ? `${base} · ${commit}` : base;
}
